import React, { Component } from "react";
import _ from 'i18n';
import {connect} from "react-redux";
import EventLineChartLegend from "../EventLineChartLegend";
import {
  fetchRegistrantLineChartCAData,
  fetchRegistrantLineChartData,
} from "../../../../../actions/thunks/eventStats";
import EventLineChartErrorHandler from "../EventLineChartErrorHandler";
import {isLeapYear, showErrorNotification} from "../../../../../services/utils";
import CompareStatsChart from "./CompareStatsChart";
import CompareStatsFilters from "./CompareStatsFilters";
import axios from "axios";
import EventLineChartFormat from "../EventLineChartFormat";
import EventLineChartLegendFormat from "../EventLineChartLegendFormat";
import { getAccumulateEventStats, getActivePremium, getCommandInfo, startCommandCumulateByFormat, startCommandGetCANbrInscriptionByFormat } from "../../../../../actions/thunks/statistics";
import CompareStatsChartFormat from "./CompareStatsChartFormat";

class CompareStats extends Component {

  constructor(props) {
    super(props);

    this.state = {
      chartLinesToShow: ['formations', 'cycles', 'saisons', 'monthly_premium', 'yearly_premium', 'congrès', 'cycles_essential'],
      fetching: true,
      data: [],
      CAdata: [],
      isError: false,
      CAfetching: true,
      CAisError: false,
      startMonth: '01',
      endMonth: '12',
      year: props.eventStatsFilter.year[0] - 1,
      dataFormat: [],
      CAdataFormat: [],
      showSpinnerFormat: false,
      activePremiumCurrentYear: {},
      activePremiumPreviousYear: {},
      accumulateEventStatsCompare: [],
      accumulateEventStatsCACompare: [],
      accumulateEventStatsCompareFetching: false,
      accumulateEventStatsCACompareFetching: false,
      formatAccumulateDataCompare: [],
      formatAccumulateCADataCompare: [],
    };

  }

  showChartLine = line => {
    const {chartLinesToShow} = this.state;

    this.setState({chartLinesToShow : [...chartLinesToShow, line]})
  }

  hideChartLine = line => {
    const {chartLinesToShow} = this.state;
    this.setState({
      chartLinesToShow : chartLinesToShow.filter(function(chartLine, i) {
        return chartLine != line
      })
    })
  }

  updateChartLinesToShow = (line) =>{
    const {chartLinesToShow} = this.state;
    const found = chartLinesToShow.find(element => element == line);
    if(found) {
      this.hideChartLine(line);
      return;
    }
    this.showChartLine(line);
  }

  fetchRegistrantLineChartData = () =>{
    const {year, isError, startMonth, endMonth} = this.state;
    const {languages, frequency, period} = this.props
    const date = period[0];
    const [yearDate, monthDate] = date.split("-");
    const previousYearDate = `${year}-${monthDate}`;
    this.setState({fetching: true, CAfetching: true, isError: false});

    this.props.fetchRegistrantLineChartData(frequency, frequency === 'DAILY' ? [previousYearDate] : [year], languages, 1).then((res) => {
      this.setState({fetching : false, data: res.data.data});
      this.props.fetchRegistrantLineChartCAData(frequency, frequency === 'DAILY' ? [previousYearDate] : [year], languages, 1).then((res) => {
          this.setState({CAfetching : false, CAdata: res.data.data});
        }
      ).catch((err) => {
        if (!axios.isCancel(err)) {
          this.setState({CAfetching: false, CAisError: true, CAdata: []});
          showErrorNotification(_('error'), _('errorOccured'));
        }
      });
    }).catch((err) => {
      if (!axios.isCancel(err)) {
        this.setState({fetching: false, isError: true, data: []});
        showErrorNotification(_('error'), _('errorOccured'));
      }
    });

    if (frequency === 'MONTHLY') {
      this.props.getActivePremium(period, frequency, startMonth, endMonth).then((res) => {
        this.setState({activePremiumCurrentYear: res.value.data.data});
  
        this.props.getActivePremium([year], frequency, startMonth, endMonth).then((res) => {
          this.setState({activePremiumPreviousYear: res.value.data.data});
        });
      });
    }

    if (frequency === 'DAILY') {
      this.setState({accumulateEventStatsCompareFetching: true, accumulateEventStatsCACompareFetching: true});
      this.props.getAccumulateEventStats(frequency, [previousYearDate], languages, 'NBR').then((res) => {
        this.setState({accumulateEventStatsCompare: res.value.data.data, accumulateEventStatsCompareFetching: false});
      });
      this.props.getAccumulateEventStats(frequency, [previousYearDate], languages, 'CA').then((res) => {
        this.setState({accumulateEventStatsCACompare: res.value.data.data, accumulateEventStatsCACompareFetching: false});
      });
    }
  }

  fetchRegistrantLineChartCAData = () =>{
    const {year, isError} = this.state;
    const {languages, frequency, period} = this.props;
    const date = period[0];
    const [yearDate, monthDate] = date.split("-");
    const previousYearDate = `${year}-${monthDate}`;
    this.setState({CAfetching: true, CAisError: false});

    this.props.fetchRegistrantLineChartCAData(frequency, frequency === 'DAILY' ? [previousYearDate] : [year], languages, true).then((res) => {
        this.setState({CAfetching : false, CAdata: res.data.data});
      }
    ).catch((err) => {
      if (!axios.isCancel(err)) {
        this.setState({CAfetching: false, CAisError: true, CAdata: []});
        showErrorNotification(_('error'), _('errorOccured'));
      }
    });
  }

  handleStartMonthChange = (startMonth) => {
    const { endMonth } = this.state;
    if (startMonth > endMonth) {
      this.setState({ endMonth: startMonth });
    }
    this.setState({ startMonth });
  };

  handleEndMonthChange = (endMonth) => {
    const { startMonth } = this.state;
    if (endMonth < startMonth) {
      this.setState({ startMonth: endMonth });
    }
    this.setState({ endMonth });
  };

  handleYearChange = (year) => {
    this.setState({ year: year });
  };

  getDateInterval = () => {
    const { startMonth, endMonth, year } = this.state;
    const baseYear = this.props.eventStatsFilter.year[0];

    const startDate = new Date(year, startMonth - 1, 1);
    const endDate = new Date(year, endMonth, 0);
    const baseEndDate = new Date(baseYear, endMonth, 0);

    const startMonthName = this.formatDate(startDate);
    let endMonthName = this.formatDate(endDate);

    if (isLeapYear(baseYear) ) {
      endMonthName = this.formatDate(baseEndDate);
    }

    return { startMonthName, endMonthName };
  }

  formatDate = date => {
    return `${date.toLocaleString('fr-FR', { day: '2-digit' })}/${date.toLocaleString('fr-FR', { month: '2-digit' })}`;
  }

  getValuesFromLocalStorage = () => {
    const startMonth = localStorage.getItem('startMonth');
    if(startMonth){
      this.setState({startMonth})
    }
    const endMonth = localStorage.getItem('endMonth');
    if(endMonth){
      this.setState({endMonth})
    }
  }

  getCANbrInscriptionByFormat = () => {
      this.setState({showSpinnerFormat : true, isFormatFetching: true, isFormatError: false});
      const {year} = this.state;
      const {frequency, languages, period, showAccumulateEventStats} = this.props;
      const date = period[0];
      const [yearDate, monthDate] = date.split("-");
      const previousYearDate = `${year}-${monthDate}`;
      
      
      this.props.startCommandGetCANbrInscriptionByFormat(frequency, frequency === 'DAILY' ? [previousYearDate] : [year], languages).then((res) => {
        // Clear previous timer
        clearInterval(this.commandTimer);

        const startCommandTimer = () => {
          // Pour éviter des requête concurrentes
          this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
          let prevRequestId = this.currRequestId;

          this.props.getCommandInfo(res.value.data.data.command.id)
            .then((resultat) => {

              if (prevRequestId !== this.currRequestId) {
                return;
              }

              if (resultat.data.data.status !== "FINISHED") {
                this.setState({ showSpinnerFormat : true, isFormatFetching: true });
                return;
              }

              this.setState({dataFormat: resultat.data.data.result.nbrInscrits, CAdataFormat: resultat.data.data.result.caffaire});

              // Arréter le timer
              clearInterval(this.commandTimer);

              if(frequency === 'DAILY' && showAccumulateEventStats) {
                this.props.startCommandCumulateByFormat(frequency, frequency === 'DAILY' ? [previousYearDate] : [year], languages, 'NBR').then((res) => {
                  // Clear previous timer
                  clearInterval(this.commandTimer);
          
                  const startCommandTimer = () => {
                    // Pour éviter des requête concurrentes
                    this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                    let prevRequestId = this.currRequestId;
          
                    this.props.getCommandInfo(res.value.data.data.command.id)
                      .then((resultat) => {
                        if (prevRequestId !== this.currRequestId) {
                          return;
                        }
          
                        if (resultat.data.data.status !== "FINISHED") {
                          this.setState({ showSpinnerFormat: true, isFormatFetching: true });
                          return;
                        }
          
                        // Arréter le timer
                        this.setState({
                          formatAccumulateDataCompare: resultat.data.data.result,
                          // showSpinner: false, 
                          // isFormatFetching: false
                        });
          
                        clearInterval(this.commandTimer);
          
                        this.props.startCommandCumulateByFormat(frequency, frequency === 'DAILY' ? [previousYearDate] : [year], languages, 'CA').then((res) => {
                          // Clear previous timer
                          clearInterval(this.commandTimer);
                  
                          const startCommandTimer = () => {
                            // Pour éviter des requête concurrentes
                            this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                            let prevRequestId = this.currRequestId;
                  
                            this.props.getCommandInfo(res.value.data.data.command.id)
                              .then((resultat) => {
                                if (prevRequestId !== this.currRequestId) {
                                  return;
                                }
                  
                                if (resultat.data.data.status !== "FINISHED") {
                                  this.setState({ showSpinnerFormat: true, isFormatFetching: true });
                                  return;
                                }
                  
                                // Arréter le timer
                                this.setState({
                                  formatAccumulateCADataCompare: resultat.data.data.result,
                                  showSpinnerFormat: false, 
                                  isFormatFetching: false
                                });
                  
                                clearInterval(this.commandTimer);
                                
                              })
                              .catch(() => {
                                clearInterval(this.commandTimer);
                              });
                          }
                  
                          this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
                        });
                        
                      })
                      .catch(() => {
                        clearInterval(this.commandTimer);
                      });
                  }
          
                  this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
                });
              }

              this.setState({showSpinnerFormat : false, isFormatFetching: false});
              
            })
            .catch(() => {
              clearInterval(this.commandTimer);
            });
        }

        this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
      })
  }

  componentDidMount() {
    this.getValuesFromLocalStorage();

    if (this.props.type === 'CA'){
      this.fetchRegistrantLineChartCAData();
    } else {this.fetchRegistrantLineChartData();}

    if (this.props.legendType === 'FORMAT') {
      this.getCANbrInscriptionByFormat();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {year, startMonth, endMonth} = this.state;
    const {languages, frequency, period} = this.props
    if (prevState.year != year || prevProps.period !== this.props.period) {
      if ( this.props.type === 'CA'){
        this.fetchRegistrantLineChartCAData();
      } else {this.fetchRegistrantLineChartData();}

      if (this.props.legendType === 'FORMAT') {
        this.getCANbrInscriptionByFormat();
      }
    }

    if (prevState.startMonth !== startMonth) {
      localStorage.setItem('startMonth' , startMonth);
      if (frequency === 'MONTHLY') {
        this.props.getActivePremium(period, frequency, startMonth, endMonth).then((res) => {
          this.setState({activePremiumCurrentYear: res.value.data.data});
    
          this.props.getActivePremium([year], frequency, startMonth, endMonth).then((res) => {
            this.setState({activePremiumPreviousYear: res.value.data.data});
          });
        });
      }
    }
    
    if (prevState.endMonth !== endMonth) {
      localStorage.setItem('endMonth' , endMonth);
      if (frequency === 'MONTHLY') {
        this.props.getActivePremium(period, frequency, startMonth, endMonth).then((res) => {
          this.setState({activePremiumCurrentYear: res.value.data.data});
    
          this.props.getActivePremium([year], frequency, startMonth, endMonth).then((res) => {
            this.setState({activePremiumPreviousYear: res.value.data.data});
          });
        });
      }
    }
  }

  render() {
    const {
      chartLinesToShow, fetching, data, isError, startMonth, endMonth, year, CAfetching, CAdata, CAisError,
      dataFormat, 
      CAdataFormat,
      showSpinnerFormat,
      activePremiumCurrentYear,
      activePremiumPreviousYear,
      accumulateEventStatsCACompare,
      accumulateEventStatsCompare,
      accumulateEventStatsCACompareFetching,
      accumulateEventStatsCompareFetching,
      formatAccumulateDataCompare,
      formatAccumulateCADataCompare,
    } = this.state;
    const {
        eventStatsFilter, 
        language, 
        chartData1, 
        chartDataCA1, 
        type, legendType, updateChartType, updateLegendType, isFetching : sourceIsFetching, isError: sourceIsError,
        updateChartLinesToShowFormat,
        chartLinesToShowFormat,
        chartLinesToShowSeason,
        formatData1,
        formatCAData1,
        isFormatFetching,
        isFormatError,
        seasonsToShow,
        frequency,
        period,
        showAccumulateEventStats,
        accumulateEventStats,
        accumulateEventStatsCA,
        accumulateEventStatsFetching,
        accumulateEventStatsCAFetching,
        formatAccumulateData,
        formatAccumulateCAData,
      } = this.props;
    
    const chartData = data;
    const chartDataCA = CAdata;

    const formatData = dataFormat;
    const formatCAData = CAdataFormat;
    const isFetching = CAfetching;
    const error = CAisError || isError;
    
    return (
      <React.Fragment>
        <div className={"flex justify-center mt-5"}>
          <hr style={{width: "100%"}}/>
        </div>
        <div>
          <CompareStatsFilters 
              startMonth={startMonth} 
              endMonth={endMonth}
              handleStartMonthChange={this.handleStartMonthChange}
              handleEndMonthChange={this.handleEndMonthChange}
              year={year} 
              handleYearChange={this.handleYearChange}
              type={type} 
              legendType={legendType}
              updateChartType={updateChartType} 
              updateLegendType={updateLegendType}
              frequency={frequency}
            />
        </div>
          {legendType === 'TYPE' ?
            (
          <div className="event-registrant-line-chart-body" >
            <div className="event-registrant-line-chart-body-aside" style={{width: '50%'}}>
              <div className={'chart-registrant-number-label mb-4 mt-4'}>
                {_('REGISTRATIONS_COMPARE_STATS') + ' et ' +  _('CA_COMPARE_STATS')}
                { ' ' + _('FROM') + ' ' + this.getDateInterval().startMonthName + ' ' + _('TO') + ' ' + this.getDateInterval().endMonthName }
              </div>
              <EventLineChartLegend
                updateChartLinesToShow={this.updateChartLinesToShow}
                chartLinesToShow={chartLinesToShow}
                chartData={chartData} 
                chartDataCA={chartDataCA} 
                fetching={isFetching || sourceIsFetching}
                isError={error || sourceIsError} 
                sourceData={chartData1}
                sourceDataCA={chartDataCA1}
                startMonth={frequency === 'DAILY' ? null : startMonth} 
                endMonth={frequency === 'DAILY' ? null : endMonth} 
                year={year} 
                type={type} 
                frequency={frequency}
                sourceYear={eventStatsFilter.year[0]}
                showCompareStats={this.props.showCompareStats}
                activePremium={this.props.activePremium}
                activePremiumCurrentYear={activePremiumCurrentYear}
                activePremiumPreviousYear={activePremiumPreviousYear}
              />
            </div>
            <div className="event-registrant-line-chart-body-main" style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '50%'}}>
              {
                error ?
                  <EventLineChartErrorHandler
                    fetchRegistrantLineChartData={this.fetchRegistrantLineChartData}/>
                  :
                  <CompareStatsChart 
                    data1={type === 'CA' ? (showAccumulateEventStats ? accumulateEventStatsCA : chartDataCA1) : (showAccumulateEventStats ? accumulateEventStats : chartData1)} 
                    data2={type === 'CA' ? (showAccumulateEventStats ? accumulateEventStatsCACompare : chartDataCA) : (showAccumulateEventStats ? accumulateEventStatsCompare : chartData)} 
                    chartLinesToShow={chartLinesToShow}
                    fetching={isFetching || sourceIsFetching || accumulateEventStatsCompareFetching || accumulateEventStatsCACompareFetching || accumulateEventStatsFetching || accumulateEventStatsCAFetching} 
                    language={language} 
                    startMonth={startMonth} 
                    endMonth={endMonth} 
                    year1={eventStatsFilter.year[0]} 
                    year2={year} 
                    type={type} 
                    updateType={updateChartType}
                    frequency={frequency}
                  />
              }
            </div>
          </div>
          )
          : 
          (
            <div className="event-registrant-line-chart-body" >
            <div className="event-registrant-line-chart-body-aside" style={{width: '50%'}}>
              <div className={'chart-registrant-number-label mb-4 mt-4'}>
                {_('REGISTRATIONS_COMPARE_STATS') + ' et ' +  _('CA_COMPARE_STATS')}
                { ' ' + _('FROM') + ' ' + this.getDateInterval().startMonthName + ' ' + _('TO') + ' ' + this.getDateInterval().endMonthName }
              </div>
              <EventLineChartLegendFormat
                updateChartLinesToShow={updateChartLinesToShowFormat}
                chartLinesToShowFormat={chartLinesToShowFormat}
                formatData={formatData}
                formatCAData={formatCAData}
                fetching={isFormatFetching}
                isError={isFormatError} 
                type={legendType}
                showSpinner={showSpinnerFormat}
                seasonsToShow={seasonsToShow}
                frequency={frequency}
                period={period}
                sourceFormatData={formatData1}
                sourceFormatDataCA={formatCAData1}
                startMonth={frequency === 'DAILY' ? null : startMonth} 
                endMonth={frequency === 'DAILY' ? null : endMonth} 
                year={year} 
                sourceYear={eventStatsFilter.year[0]}
              />
            </div>
            <div className="event-registrant-line-chart-body-main" style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '50%'}}>
              {
                error ?
                  <EventLineChartErrorHandler
                    fetchRegistrantLineChartData={this.fetchRegistrantLineChartData}/>
                  :
                  <CompareStatsChartFormat
                    data1={type === 'CA' ? formatCAData1 : formatData1} 
                    data2={type === 'CA' ? formatCAData : formatData} 
                    chartLinesToShowSeason={chartLinesToShowSeason}
                    fetching={showSpinnerFormat} 
                    language={language} 
                    startMonth={startMonth} 
                    endMonth={endMonth} 
                    year1={eventStatsFilter.year[0]} 
                    year2={year} 
                    type={type} 
                    updateType={updateChartType}
                    frequency={frequency}
                    showAccumulateEventStats={showAccumulateEventStats}
                    formatAccumulateData={formatAccumulateData}
                    formatAccumulateCAData={formatAccumulateCAData}
                    formatAccumulateDataCompare={formatAccumulateDataCompare}
                    formatAccumulateCADataCompare={formatAccumulateCADataCompare}
                  />
              }
            </div>
          </div>
          )}
          
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  language: state.params.lng,
});

const mapDispatchToProps = {
  fetchRegistrantLineChartData,
  fetchRegistrantLineChartCAData,
  startCommandGetCANbrInscriptionByFormat,
  getCommandInfo,
  getActivePremium,
  getAccumulateEventStats,
  startCommandCumulateByFormat,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareStats);





// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CompareStats/CompareStats.js